// Campus photo for /colleges/wesleyan-university: CC BY-SA 3.0, by Smartalic34 ( talk ), from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACollege_row_at_wesleyan.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/wesleyan-university/; credited under the photo.
const photo = {
    "slug": "wesleyan-university",
    "alt": "College Row, the line of historic brownstone buildings at Wesleyan University in Middletown, Connecticut",
    "src": "/colleges/wesleyan-university/campus-1600.webp",
    "srcSmall": "/colleges/wesleyan-university/campus-800.webp",
    "srcMid": "/colleges/wesleyan-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/wesleyan-university/og.jpg",
    "title": "College row at wesleyan",
    "author": "Smartalic34",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACollege_row_at_wesleyan.jpg",
    "read": "2026-10-02"
};

export default photo;
